import { ClientRegistrationService } from '../../../ClientRegistrationService';
import { createRequestBuilder, HttpRequest } from '@quickplay/foundation';
import { ClientRegistrationRequest } from './ClientRegistrationRequest';
import { PlatformAuthorizer, AuthorizationUtil } from '@quickplay/platform-authorizer';
import { ClientAuthorizationToken } from '../model/ClientAuthorizationToken';
import { ClientRegistrationResponse } from './ClientRegistrationResponse';

export function createClientRegistrationServiceImpl(
  clientRegistrationEndPointUrl: string,
  platform: PlatformAuthorizer,
): ClientRegistrationService {
  const clientRegistrationService: ClientRegistrationService = {
    registerDevice(uniqueId: string, castDeviceId?: string): Promise<ClientAuthorizationToken> {
      return registerDevice(uniqueId, castDeviceId);
    },
  };

  async function registerDevice(uniqueId: string, castDeviceId?: string): Promise<ClientAuthorizationToken> {
    try {
      const request = buildClientRegistrationRequest(uniqueId, castDeviceId);
      const result = await AuthorizationUtil.makeAuthorizedRequest<any, ClientRegistrationResponse>(request, platform);

      return {
        secret: result.data.secret,
        expiry: result.data.expiry,
        deviceId: result.data.deviceId,
      };
    } catch (error) {
      return Promise.reject(error);
    }
  }

  function buildClientRegistrationRequest(
    uniqueId: string,
    castDeviceId?: string,
  ): HttpRequest<ClientRegistrationRequest> {
    const clientRegistrationRequestData: ClientRegistrationRequest = {
      uniqueId: uniqueId,
    };

    if (castDeviceId) {
      clientRegistrationRequestData.castDeviceId = castDeviceId;
    }
    return createRequestBuilder<ClientRegistrationRequest>()
      .url(clientRegistrationEndPointUrl)
      .path('/device/app/register')
      .post(clientRegistrationRequestData)
      .build();
  }

  return clientRegistrationService;
}
